import React, { useState } from 'react'
import Turnstile from 'react-turnstile'

const HumanLayer1 = ({children}) => {

    const [isHuman, setIsHuman] = useState(false)

    if (isHuman) {
        return (
            <>{children}</>
        )
    }
  return (
    <>
        
        <div className="fixed top-0 left-0 w-screen h-screen bg-white flex items-center justify-center">
            <Turnstile
                sitekey="0x4AAAAAABgIF01QHljtWIc2"
                onVerify={(token) => {setIsHuman(true)}}
            />
        </div>

    </>
  )
}

export default HumanLayer1